import storeInfo from '../store'
import { JobItem } from '../types'
import { JobsType } from './types'

import { StatusBoxProps } from 'src/components/UI/CustomUI/molecules/StatusBox/types'
import { STATUS } from 'src/helpers/constants'

export const getJobs = () => (): JobsType => {
  const { jobs } = storeInfo.store.getState()
  return jobs
}

export const getJobsForTable = () => (): JobItem[] => {
  const state = storeInfo.store.getState()
  const { jobs } = state
  if (!jobs) return []

  const territorySuccessManagers = state.territory?.territorySuccessManagers || []
  const affiliatesStages = state.companies?.allItems || []

  return jobs?.items?.map((item: JobItem) => {
    const csm = territorySuccessManagers.find((t: any) => t.id === item.successManagerId)
    const affiliate = item.properties.affiliate
      ? affiliatesStages.find((a: any) => a.affiliateId?.toLowerCase() === item.properties.affiliate?.toLowerCase())
      : null

    return {
      ...item,
      totalValue: item?.properties?.totalValue,
      fullAddress: item?.properties?.fullAddress,
      city: item?.properties?.address?.city,
      territory: item?.properties?.territory?.title,
      affiliate: affiliate ? affiliate?.name : '-',
      affiliateType: item?.properties?.affiliateType,
      territoryManager: item?.properties?.territory?.territoryManager,
      client: item?.properties?.contacts?.length > 0 ? item?.properties?.contacts[0]?.fullName : '',
      publicId: item?.properties?.publicId,
      csm: csm ? csm?.firstName + ' ' + csm?.lastName : ''
    }
  }) || []
}

export const getTotalJobs = () => {
  const { jobs } = storeInfo.store.getState()
  return jobs ? Number(jobs.total) : 0
}

export const getJobsSearch = (jobs: JobItem[], search: string) => {
  if (search === '') return jobs
  return jobs.filter(
    vendor => vendor.status?.toLowerCase().includes(search?.toLowerCase())
  )
}

export const getJobsUser = (jobs: JobItem[], user: string) => {
  if (user === 'All users' || user === '') return jobs
  return jobs.filter(vendor => vendor.csm?.toLowerCase().includes(user?.toLowerCase()))
}

export const getJobsByFilter = (jobs: JobItem[], user: string) => (): JobItem[] => {
  const users = getJobsUser(jobs, user)
  return users
}

export const getJobsStatus = (jobs: JobItem[], status: string) => {
  return jobs.filter(job => job.properties.affiliateType?.toLowerCase().includes(status))
}

export const getJobsCSV = () => storeInfo.store.getState().jobs.jobsCSV

export const getJobsBoxes = () => (): StatusBoxProps[] => {
  const { jobs: { counts } } = storeInfo.store.getState()
  const complete = counts?.find((count: { status: string }) => 
    count.status?.includes(STATUS.COMPLETE) || count.status?.includes(STATUS.V2_COMPLETED)
  )
  const v2NewPendingAssignment = counts?.find((count: { status: string }) => count.status?.includes(STATUS.V2_NEW_PENDING_ASSIGNMENT))
  const v2Assigned = counts?.find((count: { status: string }) =>
    count.status?.includes(STATUS.V2_ASSIGNED) || count.status?.includes(STATUS.DISPATCHED)
  )
  const v2Scheduled = counts?.find((count: { status: string }) => count.status?.includes(STATUS.V2_SCHEDULED))
  const v2InProgress = counts?.find((count: { status: string }) =>
    count.status?.includes(STATUS.V2_IN_PROGRESS) || count.status?.includes(STATUS.REVIEW)
  )
  const v2InvoiceReceived = counts?.find((count: { status: string }) => count.status?.includes(STATUS.V2_INVOICE_RECEIVED))
  const v2Cancelled = counts?.find((count: { status: string }) => count.status?.includes(STATUS.V2_CANCELLED))

  const data: StatusBoxProps[] = [
    {
      statName: 'Active',
      statValue: (v2NewPendingAssignment?.count ?? 0)
        + (v2Assigned?.count ?? 0)
        + (v2Scheduled?.count ?? 0)
        + (v2InProgress?.count ?? 0),
      borderColor: 'var(--orange700)',
      minWidth: '310px',
      firstColumn: [
        v2NewPendingAssignment ? v2NewPendingAssignment.count.toString() : '-', 'Pending Assignment',
        v2Assigned ? v2Assigned.count.toString() : '-', 'Assigned'
      ],
      sndColumn: [
        v2Scheduled ? v2Scheduled.count.toString() : '-', 'Scheduled',
        v2InProgress ? v2InProgress.count.toString() : '-', 'In Progress'
      ],
      layer: 0,
    },
    { statName: 'Invoice Received', statValue: v2InvoiceReceived ? v2InvoiceReceived.count : 0, borderColor: 'var(--lightBlue700)', layer: 1 },
    { statName: 'Completed', statValue: complete ? complete.count : 0, borderColor: 'var(--lightBlue700)', layer: 1 },
    { statName: 'Cancelled', statValue: v2Cancelled ? v2Cancelled.count : 0, borderColor: 'var(--lightBlue700)', layer: 1 }
  ]
  return data
}

export const getStatistiscs = () => (): any[] => {
  const { jobs: { counts } } = storeInfo.store.getState()
  const scheduling = counts?.find((count: { status: string }) => count.status?.includes(STATUS.SCHEDULING))
  const pending = counts?.find((count: { status: string }) => count.status?.includes(STATUS.DISPATCH_PENDING))
  const dispatched = counts?.find((count: { status: string }) => count.status?.includes(STATUS.DISPATCHED))
  const review = counts?.find((count: { status: string }) => count.status?.includes(STATUS.REVIEW))
  const complete = counts?.find((count: { status: string }) => count.status?.includes(STATUS.COMPLETE))
  const invoicedSent = counts?.find((count: { status: string }) => count.status?.includes(STATUS.INVOICE_SENT))
  const overdue = counts?.find((count: { status: string }) => count.status?.includes(STATUS.OVERDUE))

  const data = [
    { jobs: 'Scheduling', jobNumber: scheduling ? scheduling.count.toString() : '-', date: 'In Review', dateNumber: review ? review.count.toString() : '-' },
    { jobs: 'Pending', jobNumber: pending ? pending.count.toString() : '-', date: 'Needs Invoice', dateNumber: invoicedSent ? invoicedSent.count.toString() : '-' },
    { jobs: 'Dispatched', jobNumber: dispatched ? dispatched.count.toString() : '-', date: 'Overdue', dateNumber: overdue ? overdue.count.toString() : '-' },
    { jobs: 'Completed', jobNumber: complete ? complete.count.toString() : '-' }
  ]

  return data
}
